import axiosInstance from "./axiosConfig";

// Ensure this endpoint matches your backend User Routes
// Based on previous chats, backend likely has /user/login or similar.
// I need to check backend routes, but assuming /user/login for now based on 'userRoutes' in index.js.

const login = async (email, password) => {
    const response = await axiosInstance.post("/doctor/doctorLogin", { email, password });
    if (response.data.token) {
        localStorage.setItem("user", JSON.stringify(response.data));
        localStorage.setItem("token", response.data.token);
    }
    return response.data;
};

const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
};

const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem("user"));
};

const forgotPassword = async (email) => {
    const response = await axiosInstance.post("/doctor/forgetPassword", { email });
    return response.data;
};

const resetPassword = async (email, otp, password) => {
    const response = await axiosInstance.post("/doctor/resetPassword", { email, otp, password });
    return response.data;
};

const authService = {
    login,
    logout,
    getCurrentUser,
    forgotPassword,
    resetPassword,
};

export default authService;
